<template>
  <StatCard
    :icon="require(`@/assets/images/icon-call_duration.svg`)"
    :loading="lastHourCallDurationLoading"
    :error="lastHourCallDurationErrorMessage"
    @retry="fetchLastHourCallDuration"
  >
    <template #head>
      <div class="d-flex flex-column align-items-center">
        <p class="m-0">
          {{ $t('dashboard.statistics.service-level-details.last-hour.title') }}
        </p>
        <h3 class="m-0">
          {{ lastHourDuration }}
        </h3>
      </div>
    </template>
    <template #foot>
      <h5 class="m-0 text-center text-primary">
        {{
          $t('dashboard.statistics.service-level-details.last-hour.foot-title')
        }}
      </h5>
      <p class="m-0 text-center text-muted">
        {{
          $t('dashboard.statistics.service-level-details.last-hour.based-on')
        }}
        {{ lastHourCallDuration.totalAnsweredCount }}
        {{
          $t(
            'dashboard.statistics.service-level-details.last-hour.calls-of-total'
          )
        }}
        {{ lastHourCallDuration.total }}
        {{ $t('dashboard.statistics.service-level-details.last-hour.calls') }}
      </p>
    </template>
  </StatCard>
</template>
<script>
import StatCard from '../../elements/StatCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    StatCard
  },
  computed: {
    ...mapGetters([
      'lastHourCallDuration',
      'lastHourCallDurationLoading',
      'lastHourCallDurationErrorMessage'
    ]),
    lastHourDuration() {
      if (!this.lastHourCallDuration) return ''
      const [
        hours,
        minutes,
        seconds
      ] = this.lastHourCallDuration.totalAnsweredDuration
      return this.$t('shared.time', { hours, minutes, seconds })
    }
  },
  methods: {
    ...mapActions(['fetchLastHourCallDuration'])
  },
  mounted() {
    this.fetchLastHourCallDuration()
  }
}
</script>
<style lang="scss" scoped></style>
